import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-locize-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

const backendOptions = {
    projectId: process.env.REACT_APP_LOCIZE_PROJECT_ID,
    apiKey: process.env.REACT_APP_LOCIZE_API_KEY,
    referenceLng: 'en',
}

i18n
.use(Backend)
.use(LanguageDetector)
.use(initReactI18next)
.init({
    lng: 'en',
    saveMissing: process.env.NODE_ENV === 'development' ? true : false,
    updateMissing: process.env.NODE_ENV === 'development' ? true : false,
    fallbackLng: 'en',    
    backend: backendOptions,
    debug: process.env.NODE_ENV === 'development' ? true : false
})

export default i18n